import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../hooks';
import { Button } from 'semantic-ui-react';
import { TableUser } from '../../../components/Admin/User';
import { UserModal } from '../../../components/Shared';
import { FormUser } from '../../../components/Admin/User';
import { size } from 'lodash';
import { User } from '../../../api';
import './UserPage.scss';

const userController = new User();

export function UserPage() {

  const [users, setUsers] = useState(null);
  const [reload, setReload] = useState(false);
  const { accessToken } = useAuth();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await userController.getUsers(accessToken);
        setUsers(response);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [reload]);

  if (size(users) === 0) return <p>not results</p>;

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState)

  // recargar la table
  const onReload = () => setReload((prevState) => !prevState);

  return (
    <>
      <div className='user-page'>
        <Button
            className='user-page__create-button'
            primary
            onClick={onOpenCloseModal}
          >
            Create User
          </Button>
      </div>

      <TableUser users={users} onReload={onReload} />

      <UserModal
        show={showModal}
        close={onOpenCloseModal}
        title="Create User"
      >
        <FormUser close={onOpenCloseModal} onReload={onReload} />
      </UserModal>
    </>
  );
}
